import React from 'react';
import {Moon,Sun} from 'lucide-react';
import {useTheme} from '../hooks/useTheme';
export default function ThemeToggle(){
 const {theme,toggleTheme}=useTheme();const light=theme==='light';
 return <button type="button" className="sidebar-theme-toggle" role="switch" aria-label="Светлая тема" aria-checked={light} title={light?'Включить тёмную тему':'Включить светлую тему'} onClick={toggleTheme}><span className="sidebar-theme-label">{light?'Светлая тема':'Тёмная тема'}</span><span className="theme-switch-track" aria-hidden="true"><Moon size={12}/><Sun size={12}/><span className="theme-switch-thumb"/></span></button>;
}
